import { Component } from '@angular/core';
import { ControlValueAccessor, FormBuilder, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-profile-otp-code',
  templateUrl: './profile-otp-code.component.html',
  styleUrls: ['./profile-otp-code.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ProfileOtpCodeComponent
    }
  ],
  standalone: false
})
export class ProfileOtpCodeComponent implements ControlValueAccessor {
  disabled = false;
  value = '';
  focus = false;
  onChange = (value: string) => ({});
  onTouched = () => ({});

  constructor(private fb: FormBuilder) {}

  registerOnChange(fn): void {
    this.onChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  onInput(event: Event) {
    this.value = (event.target as HTMLInputElement).value;
    this.onChange(this.value);
  }
}
